/**
 * Clerk organization role constants.
 * These match Clerk's built-in role identifiers.
 */
export const ORG_ROLES = {
  ADMIN: 'org:admin',
  MEMBER: 'org:member',
} as const;

/**
 * GitHub App install/configure URL for approved teams when self-serve installation is enabled
 * (also reachable at https://mindrealm.ai/install). Single source for the auth'd app's
 * install/reconnect surfaces so a stranded user can reconnect a removed installation.
 */
export const GITHUB_APP_INSTALL_URL =
  'https://github.com/apps/mindrealm-ai/installations/new';

/**
 * CLI distribution links and the canonical one-line install commands, shown verbatim
 * across the docs and getting-started pages. Single source so a domain/path change is
 * one edit. The commands are the copy-paste unit, so they live here whole.
 */
export const CLI_RELEASES_URL =
  'https://github.com/mindrealm-ai/mind/releases/latest';
export const CLI_INSTALL_COMMAND_UNIX =
  'curl -fsSL https://mindrealm.ai/install.sh | sh';
export const CLI_INSTALL_COMMAND_WINDOWS =
  'iwr -useb https://mindrealm.ai/install.ps1 | iex';

/**
 * Localhost fallback for the API base URL, used when no explicit override
 * (INTEGRATION_BASE_URL / VITE_API_URL) is set. Single source for the runtime client
 * and the integration test config so the dev default never drifts between them.
 */
export const DEFAULT_API_BASE_URL = 'http://127.0.0.1:8080';

/**
 * Public social and external profile links. Single source for the footer and any
 * other outbound UI. Keep in sync with the JSON-LD `sameAs` array in index.html.
 */
export const SOCIAL_LINKS = {
  x: 'https://x.com/mindrealm_ai',
  github: 'https://github.com/mindrealm-ai',
  blog: 'https://blog.mindrealm.ai',
  status: 'https://status.mindrealm.ai',
} as const;
